import { inject, injectable } from 'tsyringe';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type IAgentRequestMeetingRepository } from 'application/repositorySchemas/IAgentRequestMeetingRepository';
import { type IAgentRequestMeetingToCompanyClient } from 'interfaceAdapter/gatewaySchemas/IAgentRequestMeetingToCompanyClient';
import { type IAgentRequestMeetingToBuyerClient } from 'interfaceAdapter/gatewaySchemas/IAgentRequestMeetingToBuyerClient';

@injectable()
export class AgentRequestMeetingRepository implements IAgentRequestMeetingRepository {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentRequestMeetingToCompanyClient')
        public readonly agentRequestMeetingToCompanyClient: IAgentRequestMeetingToCompanyClient,
        @inject('IAgentRequestMeetingToBuyerClient')
        public readonly agentRequestMeetingToBuyerClient: IAgentRequestMeetingToBuyerClient,
    ) {}

    public async postToCompany(message: string, premium_offer: boolean, company_id: number) {
        const { data, message: responseMessage } = await this.agentRequestMeetingToCompanyClient.post({
            token: this.agentUserToken.get() || '',
            message,
            premium_offer,
            company_id,
        });

        if (responseMessage) {
            throw new Error(responseMessage);
        }

        return data;
    }

    public async postToBuyer(message: string, premium_offer: boolean, buyer_id: number) {
        const { data, message: responseMessage } = await this.agentRequestMeetingToBuyerClient.post({
            token: this.agentUserToken.get() || '',
            message,
            premium_offer,
            buyer_id,
        });

        if (responseMessage) {
            throw new Error(responseMessage);
        }

        return data;
    }
}
